import React, { useState } from "react";

const TOPICS = [
  "Gunes Sistemi", "Osmanli Tarihi", "Insan Vucudu",
  "Dunya Cografyasi", "Yapay Zeka", "Futbol"
];

const QuizForm = ({ onStartQuiz }) => {
  const [topic, setTopic] = useState("");
  const [count, setCount] = useState(10);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!topic.trim()) return;
    setLoading(true);
    try {
      await onStartQuiz(topic, "medium", count);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="panel">
      <h2 className="panel-title">Hangi konuda test olmak istersin?</h2>

      <form onSubmit={handleSubmit}>
        <input
          type="text"
          className="text-input"
          placeholder="Konu yaz veya asagidan sec..."
          value={topic}
          onChange={(e) => setTopic(e.target.value)}
          disabled={loading}
        />

        <div className="chip-group">
          {TOPICS.map((t) => (
            <button
              key={t}
              type="button"
              className={`chip ${topic === t ? 'chip-on' : ''}`}
              onClick={() => setTopic(t)}
              disabled={loading}
            >
              {t}
            </button>
          ))}
        </div>

        <div className="section-label">Soru Sayisi</div>
        <div className="seg-control">
          {[5, 10, 15].map((n) => (
            <button
              key={n}
              type="button"
              className={`seg-btn ${count === n ? 'seg-on' : ''}`}
              onClick={() => setCount(n)}
              disabled={loading}
            >
              {n}
            </button>
          ))}
        </div>

        <button type="submit" className="btn" disabled={loading || !topic.trim()}>
          {loading ? (
            <span className="btn-loading">
              <span className="spinner" />
              Sorular hazirlaniyor...
            </span>
          ) : "Quizi Baslat"}
        </button>
      </form>
    </div>
  );
};

export default QuizForm;
